module.exports = __webpack_public_path__ + "static/media/pin_mps_highlighted.372964a0.png";